import { z } from 'zod';

import { TypeIndexPage } from '../models/contentful-generated';
import { ContentfulSysSchema } from './contentful-sys.validator';
import { SeoMetadataEntrySchema } from './seo-metadata.validator';

export const IndexPageEntrySchema = z.object({
  sys: ContentfulSysSchema,
  fields: z.looseObject({
    internalName: z.string(),
    theme: z.string(),
    seoMetadata: SeoMetadataEntrySchema.optional().nullable(),
    accessType: z.enum(['Authenticated Only', 'CSR Only', 'Public']),
    pageContent: z.array(z.any()).optional().nullable(),
    translations: z.record(z.string(), z.any()).optional().nullable()
  }),
  metadata: z
    .object({
      tags: z.array(z.any()).optional().nullable()
    })
    .optional()
    .nullable()
});

export function validateIndexPageEntry(data: TypeIndexPage) {
  return IndexPageEntrySchema.safeParse(data);
}

/**
 * Returns validation result.
 *
 * @param data
 */
export function validateIndexPageEntries(data: TypeIndexPage[]) {
  return z.array(IndexPageEntrySchema).safeParse(data);
}
